import type { AppEvent } from 'src/common/events/appEvents';

type SteeringActionPayload =
  | { action: 'CONNECT_CALENDAR'; attributes: Record<string, never> }
  | {
      action: 'CREATE_CLIENT';
      attributes: { email_address: string; first_name?: string; last_name?: string };
    }
  | { action: 'CREATE_MEETING_AGENDA'; attributes: { meeting_id: string } }
  | { action: 'CREATE_MEETING_NOTES'; attributes: { meeting_id: string } }
  | { action: 'DATA_UPLOAD_FROM_MEETING'; attributes: { meeting_id: string } }
  | { action: 'DATA_UPLOAD'; attributes: { client_id: string } }
  | { action: 'CREATE_SUITABILITY_REPORT'; attributes: { client_id: string } };

export type SteeringResponse = SteeringActionPayload & {
  title: string;
  message: string;
};

export type SteeringActionType = SteeringResponse['action'];

export const SteeringPhase = {
  SUGGESTION: 'suggestion',
  FOLLOW_UP: 'follow-up',
} as const;

type SteeringPhaseType = (typeof SteeringPhase)[keyof typeof SteeringPhase];

export const SteeringEventType = {
  SUGGESTION_RECEIVED: 'SUGGESTION_RECEIVED',
  ACTION_CLICKED: 'ACTION_CLICKED',
  APP_EVENT_RECEIVED: 'APP_EVENT_RECEIVED',
  REHYDRATE: 'REHYDRATE',
  RESET: 'RESET',
} as const;

export type SteeringState = {
  phase: SteeringPhaseType;
  response: SteeringResponse | null;
  followUp: { title: string; message: string } | null;
  actionType: SteeringActionType | null;
  targetHref: string | null;
  completionEvents: AppEvent[];
};

export type SteeringEvent =
  | {
      type: typeof SteeringEventType.SUGGESTION_RECEIVED;
      response: SteeringResponse;
      completionEvents: AppEvent[];
    }
  | {
      type: typeof SteeringEventType.ACTION_CLICKED;
      followUp: { title: string; message: string };
      href: string;
    }
  | { type: typeof SteeringEventType.APP_EVENT_RECEIVED; event: AppEvent }
  | {
      type: typeof SteeringEventType.REHYDRATE;
      response: SteeringResponse;
      completionEvents: AppEvent[];
      followUp: { title: string; message: string };
      href: string;
    }
  | { type: typeof SteeringEventType.RESET };
